export default {
  title: 'Newsletter',
  sections: {
    main: {
      fields: {
        value: {
          title: 'SEU-Newsletter',
          subTitle: 'Industry knowledge delivered straight to your inbox: At SEU, we make staying informed easy. Don\'t miss a beat – we\'ll send our blog posts about industry solutions, expert insights, and SEU news straight to you.',
          text: 'To ensure you always receive our communications, please follow this short guide:' +
              '<br><br> 1. First, sign up and confirm your email address through the link we send you in our initial message.' +
              '<br> 2. If you can\'t find our email in your inbox, please check your spam folder. If the email landed there, please mark it as "Not Spam".' +
              '<br> 3. If you use Gmail, please check the "Promotions" tab. If you find our email there, drag it into your primary inbox.' +
              '<br> 4. To ensure you consistently receive our messages, we recommend adding <span style="font-weight: 600">info@seu.ch</span> to your address book or contact list.' +
              '<br> <br> Stay informed and don\'t miss any of our updates. Thank you for choosing SEU.',
          buttonLabel: 'Sign up now',
        },
      }
    }
  }
}
